import React, { useState, useEffect } from "react";
import { IAttachment } from "@types";
import { DefaultExtensionType, defaultStyles, FileIcon } from "react-file-icon";
import { createDataAttr, parseFileDataFromUrl } from "@utils";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
export type IAttachmentMessageProps = {
  message: IAttachment;
};

export const AttachmentMessage = ({ message }: IAttachmentMessageProps) => {
  // valid state
  return (
    <a
      download
      href={message.url}
      target="_blank"
      {...createDataAttr("attachment-message")}
      title={message.name}
    >
      <div className="flex h-[60px] w-[180px] gap-x-[6px] rounded-[4px] border-[1px] p-[8px] transition-colors">
        <div className="h-[32px] w-[32px] flex-shrink-0">
          <FileIcon
            {...defaultStyles[message.ext as DefaultExtensionType]}
            extension={message.ext}
          />
        </div>
        <span
          className="h-[40px] min-w-[110px] max-w-[110px] overflow-hidden text-ellipsis  line-clamp-2"
          title={message.name}
        >
          {message.name}
        </span>
      </div>
    </a>
  );
};
